




import { Component, Vue } from 'vue-property-decorator';

@Component
export default class PageDashboard extends Vue {
}
